<template>
  <!-- 企业服务-代理记账-工商年报 -->
  <div class="Invoice-body">
    <!-- 筛选 -->
    <el-form
      :model="screenData"
      :inline="true"
      class="screen"
      @submit.native.prevent="handelSearch"
    >
      <el-form-item label="订单ID：" >
      <div class="size-search">
      <el-input v-model="screenData.orderNumber" placeholder="请输入订单ID" maxlength="30"></el-input>
      </div>
      </el-form-item>
      <el-form-item label="企业名称：" class="user-Id">
      <div class="size-search">
      <el-input v-model="screenData.input" placeholder="请输入企业名称" maxlength="30"></el-input>
      </div>
      </el-form-item>
      <el-form-item label="统一社会信用代码：" class="user-Id">
      <div class="size-search">
      <el-input v-model="screenData.code" placeholder="请输入统一社会信用代码" maxlength="30"></el-input>
      </div>
      </el-form-item>
      <el-form-item label="联系电话：" class="user-Id">
      <div class="size-search">
      <el-input
      v-model="screenData.telephone"
      placeholder="请输入联系电话"
      maxlength="30"
      ></el-input>
      </div>
      </el-form-item>
      <el-form-item label="申报年份：" >
      <el-date-picker
      v-model="screenData.year"
      :clearable="false"
      type="year"
      placeholder="请选择申报年份"
      value-format="yyyy"
      >
      </el-date-picker>
      </el-form-item>
      
      <div class="screen-end">
      <el-form-item label="时间：" class="user-Id">
      <el-date-picker
      v-model="screenData.value"
      type="daterange"
      range-separator="-"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyy-MM-dd"
      unlink-panels
      clearable
      @clear="screenData.value = null"
      >
      </el-date-picker>
      </el-form-item>
      <el-form-item>
      <el-button type="primary" class="ser-btn public-style" @click="handelSearch">搜 索</el-button>
      <el-button class="heavy-btn public-style" @click="handelReset">重 置</el-button>
      </el-form-item>
      </div>
    
    </el-form>
    <!-- 上传/变更信息 -->
    <div class="table-top-Controls">
      <div class="RemainingLocation">
        <el-button type="primary" class="action-btn firm-clickable" @click="handelVisibleUp">提交多家</el-button>
        <el-button type="primary" class="action-btn firm-clickable" @click="handelChang(0)">提交一家</el-button>
      </div>
    </div>
    <!-- 列表 -->
    <div class="Table">
      <el-table :data="tableData">
        <el-table-column
          prop="orderNumber"
          :index="NIndex"
          label="订单ID"
          show-overflow-tooltip
          width="210"
        >
        </el-table-column>
        <el-table-column
          label="企业名称(统一社会信用代码)"
          width="220"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.customerName }}
            </div>
            <div>
              ({{ scope.row.customerCreditCode }})
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="registeredCapital"
          label="注册资本(万元)"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="reportYear"
          label="申报年份"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="customerPhone"
          label="联系电话"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column label="状态" 
          ><template slot-scope="scope">
            <span :class="$tool.getProxyStatusClass(scope.row)" :style="{ color: getStatusColor(scope.row) }">{{ scope.row.statusName }}</span>
          </template></el-table-column
        >
        <el-table-column
          prop="createTime"
          label="提交时间"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="操作" width="220" fixed="right">
          <template slot-scope="scope">
            <span class="span-Operation" @click="handelDetails(scope.row, 0)"
              >详情信息</span
            >
            <span
              class="span-Operation"
              @click="handelDetails(scope.row, 1)"
              v-if="scope.row.refundButton == true"
              >申请退款</span
            >
            <span
              class="span-Operation"
              @click="handelHesitation(scope.row)"
              v-if="scope.row.refundButton == true"
              >立即办理</span
            >
            <span
              class="span-Operation"
              @click="handelEvaluation(scope.row)"
              v-if="scope.row.status == 3"
              >服务评价</span
            >
            <!-- 暂时隐藏投诉
            <span class="span-Operation" @click="handelComplaint">投诉</span>
            -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 底部分页 -->
    <div class="paging-box">
      <div class="paging">
        <paging
          :pagingObj="pagingObj"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </div>
    </div>
    <InChange
      :Visible="Visible"
      :InChange="InChange"
      :options1="options1"
      :enterprise="enterprise"
      @handleCloseUp="Visible = false"
      @handleConfirm="handleConfirm"
      @handleSuccess="handleSuccess"
    ></InChange>
    <!-- 详情/退款 -->
    <DeOfRe
      :VisibleDeRe="VisibleDeRe"
      :row="row"
      :DeRe="DeRe"
      @handleCloseDeRe="VisibleDeRe = false"
      @handleConfirmDeRe="handleConfirmDeRe"
    ></DeOfRe>
    <!-- 上传 -->
    <Upload
      :VisibleUp="VisibleUp"
      :enterprise="enterprise"
      @handleCloseUp="VisibleUp = false"
      :options1="options1"
      @handleConfirmUp="handleConfirmUp"
      @handleSuccess="handleSuccess"
    ></Upload>
    <!-- 立即办理弹窗 -->
    <Hesitation
      :VisibleHesitation="VisibleHesitation"
      @handleCloseHesitation="VisibleHesitation = false"
      @handleUnHesitation="handleUnHesitation"
    ></Hesitation>
    <!-- 服务评价弹窗 -->
    <EvaluationDialog
      :VisibleEvaluation="VisibleEvaluation"
      :orderNumber="orderNumber"
      :handleTypeName="handleTypeName"
      :businessTypeName="businessTypeName"
      :evaluatedName="evaluatedName"
      @handleCloseEvaluation="handleCloseEvaluation"
      @handleSuccess="handleEvaluationSuccess"
    ></EvaluationDialog>
  </div>
</template>

<script>
import Hesitation from "../Bookkeeping/components/IndexCom/Hesitation.vue"; //立即办理弹窗

import * as API from "@/assets/api/Agency/Enterprise.js";
import InChange from "./components/Taxation/InChange.vue";
import Upload from "./components/Taxation/Upload.vue";
import DeOfRe from "./components/Taxation/NewDetails.vue";
import EvaluationDialog from "../../components/EvaluationDialog.vue"; //服务评价弹框
// 引入分页组件
import paging from "../../../../../../components/paging.vue";
export default {
  data() {
    return {
      screenData: {
        value: null, // 时间
        input: "", //企业名称
        code: "", //统一社会信用代码
        telephone: "", //联系电话
        year: "",
        orderNumber:'',//订单id
      },
      options: [], //变更类型选择
      tableData: [],
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页数据
      Visible: false, // 0员工信息变更 1上传员工信息变更
      InChange: 0, // 0员工信息变更 1上传员工信息变更
      VisibleDeRe: false, //0详情
      VisibleUp: false, //上传
      options1: [],
      enterprise: {}, //平台企业信息
      row: {}, //详情
      DeRe: 0, // 0查看  1退款
      VisibleHesitation: false, //立即办理弹窗
      VisibleEvaluation: false, //服务评价弹窗
      evaluatedName: "", // 被评价人
      orderNumber: "", //订单号
      handleTypeName: "", //服务类型
      businessTypeName: "", //服务类别
    };
  },
  watch: {},
  components: {
    Hesitation,
    paging,
    InChange, //员工信息变更/上传员工信息变更
    DeOfRe, //详情
    Upload,
    EvaluationDialog, //服务评价弹框
  },
  created() {
    this.yearTaxReportList();
    this.companySelectCustomers();
  },
  mounted() {
    // 每次进入页面都会重新监听
    // 购买/续费代理记账在index页面，购买后本页面不知道没有刷新客户列表接口，
    // 在办理服务时就会出现已经购买代理记账知道本公司的纳税类型但表单中仍需选择
    // 调用此方法购买代理记账以后 本页面监听到直接刷新客户列表接口
    this.$bus.$on("refresh-company-customers", this.handleRefresh);
  },
  beforeDestroy() {
    this.$bus.$off("refresh-company-customers", this.handleRefresh);
  },
  methods: {
    handleRefresh() {
      this.companySelectCustomers();
    },
    // 点击上传
    handelVisibleUp() {
      if (!this.$checkAction()) return;
      this.VisibleUp = true;
    },
    //付款成功
    handleSuccess() {
      this.VisibleUp = false;
      this.Visible = false;
      this.yearTaxReportList();
    },
    // 立即办理确定
    handleUnHesitation() {
      this.$tool
        .InvoiceProcess(
          "/global/proxy/yearTaxProcess",
          this.row.orderNumber
        )
        .then((res) => {
          if (res.code == 0) {
            this.$tool.PromptBox("success", "操作成功");
            this.yearTaxReportList();
          }
        });
      this.VisibleHesitation = false;
    },
    //立即办理
    handelHesitation(row) {
      if (!this.$checkAction()) return;
      this.row = row;
      this.VisibleHesitation = true;
    },
    //重置
    handelReset() {
      this.pagingObj.currentPage = 1;
      this.screenData = {
        value: null, // 时间
        input: "", //企业名称
        code: "", //统一社会信用代码
        telephone: "", //联系电话
        year: "",
        orderNumber:'',//订单id
      };
      this.yearTaxReportList(); // 列表
    },
    //搜索
    handelSearch() {
      this.pagingObj.currentPage = 1;
      this.yearTaxReportList(); // 列表
    },
    // // 列表
    yearTaxReportList() {
      // 处理时间
      var time;
      var timeEnd;
      var range = this.screenData.value;
      if (Array.isArray(range) && range.length === 2 && range[0] && range[1]) {
        time = range[0] + " " + "00:00:00";
        timeEnd = range[1] + " " + "23:59:59";
      }
      var data = {
        data: {
          customerName: this.screenData.input, //客户名称
          phone: this.screenData.telephone,
          customerCreditCode: this.screenData.code, //统一社会信用代码
          reportYear: this.screenData.year,

          startTime: time,
          endTime: timeEnd,
          orderNumber:this.screenData.orderNumber
        },
      };
      API.yearTaxReportList(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      ).then((res) => {
        this.tableData = res.data.list;
        this.pagingObj.totalDevice = res.data.total;
      });
    },
    //查询客户列表(客户下拉选择)
    companySelectCustomers() {
      if (!this.$checkActionIpu()) return;
      API.companySelectCustomers().then((res) => {
        this.enterprise = res.data.self;
        var arr = res.data.customers;
        arr.unshift(res.data.self);
        this.options1 = arr;
      });
    },
    // 点击员工信息变更
    handelChang(num, row) {
      if (!this.$checkAction()) return;
      this.InChange = num;
      this.Visible = true;
    },

    // 员工信息变更 确认
    handleConfirm() {
      this.yearTaxReportList();
      this.Visible = false;
    },
    // 上传员工信息变更 确认
    handleConfirmUp() {
      this.yearTaxReportList();
      this.VisibleUp = false;
    },
    // 表格-详情 / 申请退款
    handelDetails(row, num) {
      console.log(row, "row");
      this.row = row;
      this.DeRe = num;
      if (num == 1) {
        if (!this.$checkAction()) return;
        this.VisibleDeRe = true;
      } else {
        this.VisibleDeRe = true;
      }
    },
    // 表格 - 详情/退款弹窗确认
    handleConfirmDeRe(textarea) {
      this.$tool
        .Refund(
          "/global/proxy/yearTaxRequestRefund",
          this.row.orderNumber,
          textarea
        )
        .then((res) => {
          if (res.code == 0) {
            this.$tool.PromptBox("success", "操作成功");
            this.yearTaxReportList();
          }
        });
      this.VisibleDeRe = false;
    },
    // 分页

    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      this.yearTaxReportList();
    },
    // 服务评价
    handelEvaluation(row) {
      if (!this.$checkAction()) return;
      this.orderNumber = row.orderNumber;
      this.handleTypeName = "代理记账"; 
      this.businessTypeName = "工商年报";
      this.evaluatedName = (row.evaluatedName || row.beEvaluatedName || row.handlerName || row.staffName || "");
      this.VisibleEvaluation = true;
    },
    // 关闭服务评价弹框
    handleCloseEvaluation() {
      this.VisibleEvaluation = false;
    },
    // 服务评价成功
    handleEvaluationSuccess() {
      this.yearTaxReportList();
    },

    getStatusColor(row) {
      return this.$tool.getProxyStatusColor(row);
    },
    handelComplaint() {
      this.$router.push({ path: "/Firm/firmComplain" });
    },
    //表格分页序号
    NIndex(index) {
      // 当前页数 - 1 * 每页数据条数 + 1
      const page = this.pagingObj.currentPage; // 当前页码
      const pagesize = this.pagingObj.pageSize; // 每页条数
      return index + 1 + (page - 1) * pagesize;
    },
  },
};
</script>

<style scoped lang="less">
/* 主内容区滚动条样式 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  height: 8px; /* 主内容区水平滚动条高度 */
}
::v-deep .el-table__fixed-right {
  height: 100% !important; /* 覆盖默认高度计算 */
}
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #c0c0c0; /* 灰色滑块，比轨道深一些 */
  border-radius: 4px; /* 可选：滑块圆角 */
}
::v-deep .el-table__body-wrapper {
  scrollbar-width: thin; /* Firefox 中"thin"约 8px 粗细 */
  scrollbar-color: #c0c0c0 #f5f5f5; /* 滑块色 + 轨道色 */
}

.Invoice-body {
  width: 100%;
  height: 100%;
  font-family: PingFangSC-Medium;
  font-weight: 400;
  // 筛选
  .screen {
    margin-top: 10px;
    margin-bottom: 0;
    position: relative;
}
  // 表上方的操作项
  .table-top-Controls {
    width: 100%;
    height: 35px;
    display: flex;
    align-items: center;
    .action-btn {
      width: 100px;
      height: 35px;
      background: #409eff !important;
      border-color: #409eff !important;
      border-radius: 5px;
      font-size: 14px;
      color: #ffffff !important;
      border: none;
      font-family: inherit;
      padding: 0 !important;
      line-height: 1 !important;
      display: inline-flex !important;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .RemainingLocation {
      display: flex;
      flex: 1;
      justify-content: flex-end;
      align-items: center;
      .action-btn {
        margin-left: 20px;
      }
      .outline-btn {
        background: #ffffff;
        color: #409eff ;
        border: 1px solid #409eff ;
        box-sizing: border-box;
      }
    }
  }
  //   表格
  .Table {
    min-height: 450px;
    margin-top: 30px;
    // border: 1px solid gold;
    .span-Operation {
      color: #409eff ;
      margin-left: 10px;
      cursor: pointer;
    }
    .span-Operation:nth-child(1) {
      margin-left: 0px;
    }
  }
  // 分页
  .paging-box {
    width: 100%;
    height: 22px;
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    .paging {
      width: 90%;
      height: 100%;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
